import { render, staticRenderFns } from "./SectionIntroductionDetail.vue?vue&type=template&id=1cf30342&scoped=true&"
import script from "./SectionIntroductionDetail.vue?vue&type=script&lang=js&"
export * from "./SectionIntroductionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SectionIntroductionDetail.vue?vue&type=style&index=0&id=1cf30342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf30342",
  null
  
)

export default component.exports